import { StressTrendData } from 'utils/apiClient'
import moment from 'moment'
import User from './user'

export default class StressTrend {
  id: number
  date: moment.Moment
  minValue: number
  maxValue: number
  averageValue: number
  normalCount: number
  warningCount: number
  dangerCount: number
  user: User
  createdAt: moment.Moment

  constructor(
    id: number,
    date: moment.Moment,
    minValue: number,
    maxValue: number,
    averageValue: number,
    normalCount: number,
    warningCount: number,
    dangerCount: number,
    user: User,
    createdAt: moment.Moment,
  ) {
    this.id = id
    this.date = date
    this.minValue = minValue
    this.maxValue = maxValue
    this.averageValue = averageValue
    this.normalCount = normalCount
    this.warningCount = warningCount
    this.dangerCount = dangerCount
    this.user = user
    this.createdAt = createdAt
  }

  static load(data: StressTrendData): StressTrend {
    return new StressTrend(
      data.id,
      moment.unix(data.timestamp),
      data.minValue,
      data.maxValue,
      data.averageValue,
      data.normalCount,
      data.warningCount,
      data.dangerCount,
      User.load(data.user),
      moment(data.createdAt),
    )
  }

  static loadAll(data: StressTrendData[]): StressTrend[] {
    return data.map((item) => this.load(item))
  }
}
